import { ClientAPI, MakeRequest } from './commonTypes';
import wrap from './wrap';

export { RestAdapter } from './restAdapter';
export * from './exportTypes';

const createPlainClient = (makeRequest: MakeRequest): ClientAPI => {
  const wrapParams = { makeRequest };
  return {
    raw: {
      get: (url, config) =>
        makeRequest({
          entityType: 'Http',
          action: 'get',
          params: { url, config },
        }),
      patch: (url, payload, config) =>
        makeRequest({
          entityType: 'Http',
          action: 'patch',
          params: { url, config },
          payload,
        }),
      post: (url, payload, config) =>
        makeRequest({
          entityType: 'Http',
          action: 'post',
          params: { url, config },
          payload,
        }),
      put: (url, payload, config) =>
        makeRequest({
          entityType: 'Http',
          action: 'put',
          params: { url, config },
          payload,
        }),
      delete: (url, config) =>
        makeRequest({
          entityType: 'Http',
          action: 'delete',
          params: { url, config },
        }),
      http: (url, config) =>
        makeRequest({
          entityType: 'Http',
          action: 'request',
          params: { url, config },
        }),
    },
    serverConfig: {
      get: wrap(wrapParams, 'ServerConfig', 'get'),
      getMany: wrap(wrapParams, 'ServerConfig', 'getMany'),
      create: wrap(wrapParams, 'ServerConfig', 'create'),
      del: wrap(wrapParams, 'ServerConfig', 'del'),
      update: wrap(wrapParams, 'ServerConfig', 'update'),
    },
    facetSearchConfig: {
      get: wrap(wrapParams, 'FacetSearchConfig', 'get'),
      getMany: wrap(wrapParams, 'FacetSearchConfig', 'getMany'),
      create: wrap(wrapParams, 'FacetSearchConfig', 'create'),
      update: wrap(wrapParams, 'FacetSearchConfig', 'update'),
      del: wrap(wrapParams, 'FacetSearchConfig', 'del'),
    },
    server: {
      get: wrap(wrapParams, 'Server', 'get'),
      getMany: wrap(wrapParams, 'Server', 'getMany'),
      create: wrap(wrapParams, 'Server', 'create'),
      update: wrap(wrapParams, 'Server', 'update'),
      del: wrap(wrapParams, 'Server', 'del'),
    },
    advancedSearchConfig: {
      get: wrap(wrapParams, 'AdvancedSearchConfig', 'get'),
      getMany: wrap(wrapParams, 'AdvancedSearchConfig', 'getMany'),
      create: wrap(wrapParams, 'AdvancedSearchConfig', 'create'),
      update: wrap(wrapParams, 'AdvancedSearchConfig', 'update'),
      del: wrap(wrapParams, 'AdvancedSearchConfig', 'del'),
    },
    boostRule: {
      get: wrap(wrapParams, 'BoostRule', 'get'),
      getMany: wrap(wrapParams, 'BoostRule', 'getMany'),
      create: wrap(wrapParams, 'BoostRule', 'create'),
      update: wrap(wrapParams, 'BoostRule', 'update'),
      del: wrap(wrapParams, 'BoostRule', 'del'),
    },
    indexConfig: {
      get: wrap(wrapParams, 'IndexConfig', 'get'),
      getMany: wrap(wrapParams, 'IndexConfig', 'getMany'),
      create: wrap(wrapParams, 'IndexConfig', 'create'),
      update: wrap(wrapParams, 'IndexConfig', 'update'),
      del: wrap(wrapParams, 'IndexConfig', 'del'),
    },
    indexedProperty: {
      get: wrap(wrapParams, 'IndexedProperty', 'get'),
      getMany: wrap(wrapParams, 'IndexedProperty', 'getMany'),
      create: wrap(wrapParams, 'IndexedProperty', 'create'),
      update: wrap(wrapParams, 'IndexedProperty', 'update'),
      del: wrap(wrapParams, 'IndexedProperty', 'del'),
    },
    index: {
      get: wrap(wrapParams, 'Index', 'get'),
      getMany: wrap(wrapParams, 'Index', 'getMany'),
      create: wrap(wrapParams, 'Index', 'create'),
      update: wrap(wrapParams, 'Index', 'update'),
      del: wrap(wrapParams, 'Index', 'del'),
    },
    promotedItem: {
      get: wrap(wrapParams, 'PromotedItem', 'get'),
      getMany: wrap(wrapParams, 'PromotedItem', 'getMany'),
      create: wrap(wrapParams, 'PromotedItem', 'create'),
      update: wrap(wrapParams, 'PromotedItem', 'update'),
      del: wrap(wrapParams, 'PromotedItem', 'del'),
    },
    sortField: {
      get: wrap(wrapParams, 'SortField', 'get'),
      getMany: wrap(wrapParams, 'SortField', 'getMany'),
      create: wrap(wrapParams, 'SortField', 'create'),
      update: wrap(wrapParams, 'SortField', 'update'),
      del: wrap(wrapParams, 'SortField', 'del'),
    },
    stopWord: {
      get: wrap(wrapParams, 'StopWord', 'get'),
      getMany: wrap(wrapParams, 'StopWord', 'getMany'),
      create: wrap(wrapParams, 'StopWord', 'create'),
      update: wrap(wrapParams, 'StopWord', 'update'),
      del: wrap(wrapParams, 'StopWord', 'del'),
    },
    synonym: {
      get: wrap(wrapParams, 'Synonym', 'get'),
      getMany: wrap(wrapParams, 'Synonym', 'getMany'),
      create: wrap(wrapParams, 'Synonym', 'create'),
      update: wrap(wrapParams, 'Synonym', 'update'),
      del: wrap(wrapParams, 'Synonym', 'del'),
    },
    valueRange: {
      get: wrap(wrapParams, 'ValueRange', 'get'),
      getMany: wrap(wrapParams, 'ValueRange', 'getMany'),
      create: wrap(wrapParams, 'ValueRange', 'create'),
      update: wrap(wrapParams, 'ValueRange', 'update'),
      del: wrap(wrapParams, 'ValueRange', 'del'),
    },
    valueRangeSet: {
      get: wrap(wrapParams, 'ValueRangeSet', 'get'),
      getMany: wrap(wrapParams, 'ValueRangeSet', 'getMany'),
      create: wrap(wrapParams, 'ValueRangeSet', 'create'),
      update: wrap(wrapParams, 'ValueRangeSet', 'update'),
      del: wrap(wrapParams, 'ValueRangeSet', 'del'),
    },
    searchConfig: {
      get: wrap(wrapParams, 'SearchConfig', 'get'),
      getMany: wrap(wrapParams, 'SearchConfig', 'getMany'),
      create: wrap(wrapParams, 'SearchConfig', 'create'),
      update: wrap(wrapParams, 'SearchConfig', 'update'),
      del: wrap(wrapParams, 'SearchConfig', 'del'),
    },
    sort: {
      get: wrap(wrapParams, 'Sort', 'get'),
      getMany: wrap(wrapParams, 'Sort', 'getMany'),
      create: wrap(wrapParams, 'Sort', 'create'),
      update: wrap(wrapParams, 'Sort', 'update'),
      del: wrap(wrapParams, 'Sort', 'del'),
    },
    search: {
      index: wrap(wrapParams, 'Search', 'index'),
    },
  };
};

export default createPlainClient;
